<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w38wfz/tc-custom/9781504066723.jpg?1737330590464" alt="This image is the cover for the book Face Value, The Laura Di Palma Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Face Value, The Laura Di Palma Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A lawyer is drawn into a dangerous case after a love guru shakes up San Francisco in this mystery by the author of <i>A Hard Bargain</i>.</b></p><p>Leaving an expensive firm and toxic work environment behind her, attorney Laura Di Palma has opened her own practice. She’s eager for business, and she’s not about to turn away fellow lawyer Margaret Lenin.</p><p>Margaret had been struggling with a midlife crisis. Full of deep questions, she sought answers from a spiritual master, a guru by the name of Brother Mike. He led videotaped group therapy sessions to help his followers explore their spirituality and sexuality. The trouble is those tapes are now available in the XXX sections of video stores . . .</p><p>Taking the case pushes Laura far out of her comfort zone. She needs help from her ex, PI Sandy Arkelett, and their investigation leads them from stuffy boardrooms to strip clubs, porno shops, a private fantasy island—and a grisly murder scene . . .</p><p>“Absorbing . . . Multiple murders and delightfully complex characters help carry a plot that moves from a striptease bar to a guru’s mysterious island retreat. . . . A fine, intelligent story.” —<i>USA Today</i></p><p>“This latest Laura Di Palma adventure is no exception to the tight plotting, good characterizations, and page turning suspense that have typified the earlier entries in the series and that make Matera one of the best contemporary mystery novelists. . . . Highly recommend . . . Matera is too good to miss.”—<i>Booklist</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lia Matera
      </h2>
      
      <p class="authorDescription body article">Lia Matera is the Edgar, Anthony, and Macavity Award&ndash;nominated author of nine novels. A graduate of UC Hastings College of the Law, where she was editor in chief of the <I>Hastings Constitutional Law Quarterly</I>, Matera was a teaching fellow at Stanford Law School before becoming a full-time writer of legal mysteries. She lives in Santa Cruz, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49484982